import React from 'react';
import styled from 'styled-components';
import {
  Card,
  CardActions,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from '@material-ui/core';
import { IntlShape, injectIntl } from 'react-intl';
import moment from 'moment-timezone';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import { pushTo } from 'containers/services/routes-helper';
import ActionButton from 'components/Buttons/ActionButton';
import { translate } from 'containers/services/translate';
import messages from 'containers/HomePage/ValidatedClaims/messages';
import { isEmpty } from 'lodash';
import EmptyBloc from 'components/EmptyBloc';
import ValidatedFiles from 'components/SahamIcons/ValidatedFiles';
import { PAGES } from 'routes';

export interface ValidatedClaimsProps {
  intl: IntlShape;
  claims: any;
  isPreOpeningManager?: boolean;
}

const Container = styled.div`
  .container {
    width: 100%;
    height: 420px;
  }
  .title {
    text-align: left;
    font: Bold 18px/21px Roboto;
    letter-spacing: 0;
    color: #384264;
    opacity: 1;
    padding: 10px;
  }
  .headerTitle {
    text-align: left;
    font-size: 11px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Medium;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .policyNumber {
    width: 15%;
    text-align: left;
    font-size: 11px;
    letter-spacing: 0;
    color: #000000de;
    text-transform: none;
    opacity: 1;
    font-family: Roboto;
    padding-bottom: 0px;
    font-weight: Medium;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .row {
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-weight: Medium;
    font-size: 13px;
    color: #2b2727;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .claimNumber {
    width: 15%;
    border-radius: 4px;
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-weight: Medium;
    font-size: 13px;
    color: #2b2727;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .moreClaimsButton {
    text-align: left;
    font-family: Roboto;
    letter-spacing: 0;
    font-size: 12px;
    opacity: 1;
    padding-left: 10px;
    font-weight: Bold;
  }
  .tableContainer {
    background-color: #f7f7f7;
    max-height: 300px;
    overflow-y: scroll;
  }
  .consult-arrow-forward {
    width: 13px;
    margin-left: 8px;
  }
  .cardAction {
    padding: 10px;
    display: flex;
    align-items: center;
    height: 30px;
  }
`;

const ValidatedClaims: React.FC<ValidatedClaimsProps> = (
  props,
): JSX.Element => {
  return (
    <Container>
      <Card className="container">
        <CardContent className="CardContent">
          <Typography className="title">
            {translate({ ...messages.title }, props)}
          </Typography>
          <div className="tableContainer">
            {props.claims && isEmpty(props.claims.claims) ? (
              <EmptyBloc
                filetitle={translate(
                  { ...messages.noValidatedFilesMessage },
                  props,
                )}
                fileText={translate(
                  { ...messages.noValidatedFilesTitle },
                  props,
                )}
              >
                <ValidatedFiles />
              </EmptyBloc>
            ) : (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell align="left" className="policyNumber">
                      {translate({ ...messages.claimNumber }, props)}
                    </TableCell>
                    <TableCell align="left" className="headerTitle">
                      {translate({ ...messages.client }, props)}
                    </TableCell>
                    <TableCell align="left" className="headerTitle">
                      {translate({ ...messages.numberOfVictim }, props)}
                    </TableCell>
                    <TableCell align="left" className="headerTitle">
                      {translate({ ...messages.openingDate }, props)}
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {props.claims &&
                    props.claims.claims &&
                    props.claims.claims.map((row: any) => (
                      <TableRow key={row.id}>
                        <TableCell align="left" className="claimNumber">
                          {row.claimNumber}
                        </TableCell>
                        <TableCell align="left" className="row">
                          {`${row.firstName} ${row.lastName}`}
                        </TableCell>
                        <TableCell align="left" className="row">
                          {row.victims.length}
                        </TableCell>
                        <TableCell align="left" className="row">
                          {moment(row.decidedAt).format('YYYY-MM-DD')}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            )}
          </div>
        </CardContent>
        {props.claims && !isEmpty(props.claims.claims) && (
          <CardActions className="cardAction">
            <ActionButton
              size="small"
              onClick={
                props.isPreOpeningManager
                  ? pushTo(PAGES.PREOPEN_MANAGER_VALIDATED_CLAIMS)
                  : pushTo(PAGES.VALIDATED_CLAIMS)
              }
              title={translate({ ...messages.displayAllClaimsButton }, props)}
              righticon={
                <ArrowForwardIosIcon className="consult-arrow-forward" />
              }
            />
          </CardActions>
        )}
      </Card>
    </Container>
  );
};
export default injectIntl(ValidatedClaims);
